import SearchHead from "components/searchHead";
import { useTranslation } from "react-i18next";
import SearchForm from "./list/searchForm";
import { SEARCH_FORM_ID_ROOM_ROOM } from "components/constent";
import RoomList from "./list";
import {
  RoomAddInfProvider,
  RoomBaseProvider,
  RoomFilterProvider,
  RoomListProvider,
} from "./context";
import RoomCrate from "./create";
import useModalStore from "store/modal";
import useListRowInfStroe from "store/listRowInf";

export default function RoomPage() {
  const { t } = useTranslation();
  const onSetModal = useModalStore((state) => state.onSetModal);
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);

  // 객실 생성
  const onCreate = () => {
    onSetModal({
      isOpen: true,
      title: t("sub_ttl_rm_inf"),
      styles: `w-full overflow-visible`,
      inner: (
        <RoomAddInfProvider>
          <RoomBaseProvider>
            <RoomCrate />
          </RoomBaseProvider>
        </RoomAddInfProvider>
      ),
      cnclBtn: false,
    });
  };

  return (
    <>
      <SearchHead
        title={t("sub_ttl_rm")}
        formId={SEARCH_FORM_ID_ROOM_ROOM}
        isCreate
        onClick={onCreate}
      />
      <RoomListProvider>
        <RoomFilterProvider>
          <SearchForm />
        </RoomFilterProvider>
        <RoomList />
      </RoomListProvider>
    </>
  );
}
